

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { BankSetup } from "../../components/BankSetup/BankSetup";


export const BankPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Bank"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        // { text: "Company", navigateTo: "/company/Bank/list" },
        { text: "Bank", navigateTo: "/Bank" }
      ]}
      mainContents={<BankSetup />}
    />
  );
};
